import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../Competition/AddCompetition/Components/Input";
import Button from "../../components/Button/Button";
import "./SliderForm.scss";
import ToggleButton from "../../components/ToggleButton/ToggleButton";
import useFetch from "../../hooks/useFetch";
import { API_PATH } from "../../constants/medipuzzleURL";
import { useNavigate } from "react-router-dom";

type propsType = {
  data?: any;
  editform?: boolean;
  selectedNotification?: any;
  handleClickSubmit?: Function;
  handleClickUpdate?: Function;
  handleCancel?: Function;
};

export default function SliderForm({
  data,
  handleClickSubmit,
  editform,
  handleClickUpdate,
  handleCancel
}: propsType) {
  const navigate = useNavigate();
  const [images, setImages] = useState<string | undefined>("");
  const { fetchNewData } = useFetch();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isDirty }
  } = useForm(
    editform && {
      defaultValues: {
        id: data?.id,
        isAvailable: data?.isAvailable || false,
        title: data?.title || "",
        link: data?.link || "",
        file: data?.url || "",
        slug: data?.slug || ""
      }
    }
  );

  const isAvailable = watch("isAvailable");
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (editform) {
      setIsChanged(isAvailable !== data?.isAvailable);
    }
  }, [isAvailable, data?.isAvailable, editform]);

  const handleSliderImage = e => {
    const file = e.target.files[0];
    if (file) {
      setImages(URL.createObjectURL(file));
      setValue("file", file);
    }
  };

  const handleToggleChange = () => {
    setValue("isAvailable", !isAvailable);
  };

  useEffect(() => {
    if (editform && data?.url) {
      setImages(data.url);
    }
  }, [data, editform]);

  useEffect(() => {
    fetchNewData(API_PATH.SLIDER_LIST, "");
  }, [fetchNewData]);

  return (
    <div className="slider_form_container">
      <div
        style={{
          display: "flex ",
          gap: "12px",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <h3>Slider</h3>

        <div className="back_button_wrapper">
          <Button
            buttonName="< Back"
            clickHandler={() => {
              navigate("../");
            }}
            color="success"
            type="button"
          />
        </div>
      </div>

      <form
        onSubmit={handleSubmit(
          editform ? handleClickUpdate()(handleCancel) : handleClickSubmit
        )}
      >
        <div className="input_field notification_title_wrapper">
          <label htmlFor="title">
            Slider title <span className="required">*</span>
          </label>
          <Input
            required
            id="title"
            type="text"
            name="title"
            maxLength="320"
            minLength="2"
            placeholder="slider title"
            register={register}
          />
          {errors?.title?.type === "required" && (
            <p className="error">This field is required</p>
          )}
          {errors?.title?.type === "maxLength" && (
            <p className="error">slider title too long, max 300 characters</p>
          )}
          {errors?.title?.type === "minLength" && (
            <p className="error">slider title too short, min 2 characters</p>
          )}
        </div>

        <div className="input_field notification_text_wrapper">
          <div className="input_field blog_title_wrapperCompose Slider">
            <label htmlFor="title">Slider Link</label>
            <Input
              required={false}
              id="link"
              type="text"
              name="link"
              maxLength="100"
              minLength="2"
              placeholder="sliderLink"
              register={register}
            />
          </div>
        </div>
        <div className="input_field notification_text_wrapper">
          <div className="input_field blog_title_wrapperCompose Slider">
            <label htmlFor="title">Slug</label>
            <Input
              required={false}
              id="link"
              type="text"
              name="slug"
              maxLength="100"
              minLength="2"
              placeholder="slug"
              register={register}
            />
          </div>
        </div>

        <div
          className="input_field blog_title_wrapper"
          style={{ display: "flex", gap: "12px", alignItems: "center" }}
        >
          <label htmlFor="isAvailable">Available</label>
          <ToggleButton
            handleChange={handleToggleChange}
            isChecked={isAvailable}
            onLabel="isAvailable"
          />
        </div>

        <div className="input_field notification_text_wrapper">
          <label htmlFor="image">Image</label> <br />
          <input
            required={editform ? false : true}
            id="image"
            type="file"
            name="file"
            {...register}
            placeholder="Slider File"
            onChange={handleSliderImage}
            accept="image/png, image/gif, image/jpeg"
          />
          <div style={{ height: "300px", width: "400px", marginTop: "5px" }}>
            {images && (
              <img
                className="image_conslugtainer"
                src={images}
                alt="slider"
                style={{ height: "300px", width: "400px" }}
              />
            )}
          </div>
        </div>

        <div className="submit_btn_wrapper">
          <Button
            buttonName="Submit"
            type="submit"
            color="success"
            loading={false}
            disabled={editform ? !(isDirty || isChanged) : !isDirty}
            clickHandler={() => {}}
          />
        </div>
      </form>
    </div>
  );
}
